<div *ngIf="checkViewMode('edit') && attribute.key != 'Duração do projeto'">
  <label>{{ attribute.key }}: </label>
  <div>
    {{attribute.value | currency: prefixo}}
  </div>
</div>

<div *ngIf="checkViewMode('view')">
  <p><label>{{ attribute.key }}: </label> {{attribute.value | currency: prefixo}}</p>
</div>